import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Button, CssBaseline, Box, Container} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { toast } from 'react-toastify';

import { isAuthenticated } from '../../services/auth';
import PageDefault from '../../components/PageDefault';

const theme = createTheme();

export default function Login(props) {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const redirectUrl = (() => {
    const raw = queryParams.get('redirect');
    if (!raw) return '/';
    try {
      return decodeURIComponent(raw);
    } catch (e) {
      return raw;
    }
  })();

  const base64UrlEncode = (bytes) => {
    let binary = '';
    bytes.forEach((b) => {
      binary += String.fromCharCode(b);
    });
    return btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/g, '');
  };

  const randomString = (byteLength = 32) => {
    const bytes = new Uint8Array(byteLength);
    window.crypto.getRandomValues(bytes);
    return base64UrlEncode(bytes);
  };

  const sha256 = async (text) => {
    const enc = new TextEncoder();
    const data = enc.encode(text);
    const hash = await window.crypto.subtle.digest('SHA-256', data);
    return new Uint8Array(hash);
  };

  const handleGovBrLogin = async () => {
    //toast.warning("Disponível em breve...");
    try {
      const codeVerifier = randomString(64);
      const challengeBytes = await sha256(codeVerifier);
      const codeChallenge = base64UrlEncode(challengeBytes);

      const state = randomString(32);
      const nonce = randomString(32);

      sessionStorage.setItem('govbr_pkce_verifier', codeVerifier);
      sessionStorage.setItem('govbr_state', state);
      sessionStorage.setItem('govbr_nonce', nonce);
      sessionStorage.setItem('post_login_redirect', redirectUrl);

      const authorizationEndpoint = `${process.env.REACT_APP_GOVBR_ENDPOINT}/authorize`;

      const clientId = process.env.REACT_APP_GOVBR_CLIENT_ID;
      if (!clientId) {
        toast.error('REACT_APP_GOVBR_CLIENT_ID não configurado.');
        return;
      }

      const redirectUri = process.env.REACT_APP_GOVBR_REDIRECT_URI;
      const scope = 'openid email profile govbr_confiabilidades govbr_confiabilidades_idtoken';

      const params = new URLSearchParams();
      params.set('response_type', 'code');
      params.set('client_id', clientId);
      params.set('scope', scope);
      params.set('redirect_uri', redirectUri);
      params.set('nonce', nonce);
      params.set('state', state);
      params.set('code_challenge', codeChallenge);
      params.set('code_challenge_method', 'S256');

      window.location.href = `${authorizationEndpoint}?${params.toString()}`;
    } catch (e) {
      toast.error('Falha ao iniciar login com gov.br');
    }
  };

  return (isAuthenticated() ? <Navigate to={redirectUrl} /> :
    <PageDefault carregando={false} title='Login'>
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Box component="form" noValidate sx={{ mt: 1 }}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                onClick={handleGovBrLogin}
                sx={{ mt: 2, mb: 2, borderRadius: 999, textTransform: 'none' }}
              >
                Entrar com{' '}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 800,
                    fontSize: '1.05rem',
                    letterSpacing: 0.6,
                    //bgcolor: 'rgba(255,255,255,0.22)',
                    px: 0.8,
                    py: 0.15,
                    borderRadius: 999,
                  }}
                >
                  gov.br
                </Box>
              </Button>
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
    </PageDefault>
  );
}